import React from "react";

import Layout from "../components/layout";
import SEO from "../components/seo";
import Carousel from "../components/carousel";
import DalabaEstateSection from "../components/dalaba-estate-section";
import CounterCard from "../components/counterCard";
import TafInAfrica from "../components/countries";

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Carousel />
    <DalabaEstateSection />
    <CounterCard />
    <TafInAfrica />
  </Layout>
);

export default IndexPage;
